import { useEffect } from 'react';
import { useLocationStore } from '../stores/locationStore';
import { useGetLocation } from '../utils/api/requests/useQueries';

/**
 * Promotes `activeLocation` to `verifiedLocation` — the value persisted to
 * location-storage — only once the location API confirms it exists.
 *
 * Failures leave it unverified rather than clearing it. Mounted once in
 * AppAuthWrapper.
 */
export const useVerifyActiveLocation = () => {
  const activeLocation = useLocationStore(state => state.activeLocation);
  const verifiedLocation = useLocationStore(state => state.verifiedLocation);
  const confirmActiveLocation = useLocationStore(
    state => state.confirmActiveLocation
  );

  const needsVerification =
    !!activeLocation && activeLocation !== verifiedLocation;

  // Shares the ['get-location', locationNum] key with other callers, so this
  // reuses their cached result instead of adding a request.
  const { data, isSuccess } = useGetLocation(activeLocation, needsVerification);

  useEffect(() => {
    if (!needsVerification || !isSuccess || !data) return;
    confirmActiveLocation(activeLocation);
  }, [
    activeLocation,
    confirmActiveLocation,
    data,
    isSuccess,
    needsVerification,
  ]);
};
